<template>
  <div id="app">
    <LoadingIndicator
      v-if="appLoading"
      :size="17"
      loader-type="bar"
    />
    <ErrorMessage v-if="appError" />
    <transition name="fade">
      <div
        v-if="appSuccess"
        class="App__container">
        <Navbar />
        <div
          class="App__content"
          @scroll="handleScroll"
        >
          <div class="App__mainContent">
            <router-view />
          </div>
          <Footer />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  getTranslations,
  getNavigationLinks,
  getDeals,
  getDistributors,
  getCustomerTypes,
  getSuppliers,
} from '@/api';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

export default {
  name: 'App',
  components: {
    LoadingIndicator,
    Navbar,
    Footer,
    ErrorMessage,
  },
  computed: {
    appLoading() {
      return this.$store.state.loading.appLoading;
    },
    appError() {
      return this.$store.state.loading.appError;
    },
    appSuccess() {
      return this.$store.state.loading.appSuccess;
    },
  },
  created() {
    this.initializeData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initializeData() {
      getTranslations().then((response) => {
        this.seti18nTranslations(response);
        this.getInitialData();
      }).catch((error) => {
        document.getElementById('app').innerHTML = error;
        console.error(error);
      });
    },
    getInitialData() {
      this.$store.dispatch('loading/startLoading', 'app');
      Promise.all([
        getNavigationLinks(),
        getDeals(),
        getDistributors(),
        getCustomerTypes(),
        getSuppliers(),
      ]).then((values) => {
        const navigationLinks = values[0].data;
        const deals = values[1].data;
        const distributors = values[2].data;
        const customerTypes = values[3].data;
        const suppliers = values[4].data;

        this.setNavigationLinks(navigationLinks);
        this.$store.commit('deals/SET_ALL_DEALS', deals);
        this.$store.commit('filter/SET_DISTRIBUTORS', distributors);
        this.$store.commit('filter/SET_CUSTOMER_TYPES', customerTypes);
        this.$store.commit('filter/SET_SUPPLIERS', suppliers);
        this.$store.dispatch('loading/stopLoading', 'app');
        this.$store.dispatch('loading/setSuccess', 'app');
      }).catch((error) => {
        this.$store.dispatch('loading/stopLoading', 'app');
        this.$store.dispatch('loading/setError', 'app');
        console.error(error);
      });
    },
    seti18nTranslations(translations) {
      Object.entries(translations).forEach((i) => {
        if (typeof i[1] === 'object') {
          this.$i18n.add(i[0], i[1]);
        }
      });
    },
    setNavigationLinks(navigationLinks) {
      if (navigationLinks.length > 0) {
        this.$store.commit('content/SET_NAVIGATION_LINKS', navigationLinks[0].menu);
      } else {
        this.$store.commit('content/SET_NAVIGATION_LINKS', []);
      }
    },
    handleResize() {
      this.$store.commit('layout/GET_WINDOW_WIDTH', window.innerWidth);
      this.$store.commit('layout/GET_WINDOW_HEIGHT', window.innerHeight);
    },
    handleScroll() {
      this.setIsScrolledToFooter();
    },
    setIsScrolledToFooter() {
      const footer = document.getElementsByClassName('Footer')[0];
      const container = document.getElementsByClassName('App__content')[0];

      const a = footer.offsetTop;
      const b = container.offsetHeight;
      const c = container.scrollTop;

      if (c >= (a - b)) {
        this.$store.commit('layout/SET_IS_SCROLLED_TO_FOOTER', true);
      } else {
        this.$store.commit('layout/SET_IS_SCROLLED_TO_FOOTER', false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  height: 100%;
}
.App__container {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}
.App__content {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: scroll;
}
.App__mainContent {
  flex: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 2s;
}
.fade-enter-to {
  opacity: 1;
}
</style>
